import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Panel, PanelHeader, PanelBody, PanelFooter } from './../../components/panel/panel.jsx';
import { customStyles } from '../../config/app-settings.js';
import Select from 'react-select';
import axios from 'axios'
import Pagination from '../../components/pagination/pagination.jsx';
import Modal from 'react-modal';
import ShipmentForm from './shipment.js';
import moment from 'moment/moment.js';
import { isEmpty } from '../../helper/helper.js';


function ShipmentList() {

  const [dataTable, setDataTable] = useState([])
  const [state, setState] = useState({
    shipmentFromDate: moment().add(-30, 'days').format('YYYY-MM-DD'),
    shipmentToDate: moment().format('YYYY-MM-DD'),
  });
  const [formData, setFormData] = useState({
    currentPage: 1, rowsPerPage: 50,

  });
  const [modalIsOpen, setIsOpen] = useState(false);
  const [modalUid, setModalUid] = useState('')

  const handleOnChangeInputText = (e) => {
    const { name, value } = e.target

    setState(prevState => ({
      ...prevState,
      [name]: value
    }))
  }


  const handleOnChangeSelect = (option, e) => {
    if (e.action === "select-option") {
      setState(prevState => ({
        ...prevState,
        [e.name]: option.value,
      }))
    } else if (e.action === "clear") {
      setState(prevState => ({
        ...prevState,
        [e.name]: '',
      }))
    }
  }

  const onChangePageHandler = async (page) => {
    setFormData(prevState => ({ ...prevState, currentPage: page }))
    await refreshTable(page)
  }

  const onChangePageSelectHandler = async (e) => {
    setFormData(prevState => ({ ...prevState, rowsPerPage: e.target.value }))
    await refreshTable(state.currentPage, e.target.value)
  }

  const searchForm = async () => {
    await refreshTable(1)
  }

  const openShipmentForm = async (uid, e) => {
    e.preventDefault();
    setModalUid(uid)
    setIsOpen(true)
  }


  const refreshTable = async (_page = formData.currentPage, _size = formData.rowsPerPage) => {

    let params = {
      page: _page ?? formData.currentPage,
      size: _size ?? formData.rowsPerPage,
      shipperCode: state.shipperCode ?? '',
      statusCode: state.statusCode ?? '',
      courierCode: state.courierCode ?? '',
      serviceType: state.serviceType ?? '',
      waybillNo: state.waybillNo ?? '',
      fromDate: state.shipmentFromDate ?? '',
      toDate: state.shipmentToDate ?? '',
      shipmentReff: state.shipmentReff ?? '',
      batchUpload: state.batchUpload ?? ''
    }

    for (var key in params) {
      if (isEmpty(params[key])) {
        delete params[key]
      }
    }

    await axios.get(`${window.API_HOST}/v1/shipment`, { params })
      .then(res => {
        setDataTable(res.data?.data ?? [])
        setFormData(prevState => ({
          ...prevState,
          totalRows: res.data.meta.total
        }))

      }).catch(err => {

      })
  }

  useEffect(() => {

    const fetchForm = async () => {

      await axios.post(`${window.API_HOST}/ui/v1/form-shipment`)
        .then(res => {
          const data = res.data;
          setFormData(prevState => ({
            ...prevState,
            mCouriers: data.couriers ?? [],
            mServiceType: data.serviceTypes ?? [],
            mStatuses: data.statuses ?? [],
            mShippers: data.accounts ?? [],
          }))
        }).catch(err => {

        })
    }

    const asyncRefrestTable = async () => {
      await refreshTable(1)
    }

    fetchForm()
    asyncRefrestTable()

  }, []) //eslint-disable-next-line 

  return (
    <div>
      <ol className="breadcrumb float-xl-end">
        <li className="breadcrumb-item"><Link to="/home"><i className='fa fa-home'></i> Home</Link></li>
      </ol>
      <h1 className="page-header">Shipments <small></small></h1>
      <Panel>
        <PanelHeader noButton>Shipment List</PanelHeader>
        <PanelBody>
          <div className="row" >
            <div className='col-sm-4'>
              <div className="form-group row mb-0">
                <label className="col-sm-3 col-form-label text-left">Shipment Date</label>
                <div className="col-sm-4 ">
                  <input className="form-control form-control-sm" type="date" name="shipmentFromDate" onChange={handleOnChangeInputText} value={state.shipmentFromDate ?? ""} />
                </div>
                <label className="col-sm-1 col-form-label text-center"> <span>to</span></label>
                <div className="col-sm-4">
                  <input className="form-control form-control-sm" type="date" name="shipmentToDate" onChange={handleOnChangeInputText} value={state.shipmentToDate ?? ""} />
                </div>
              </div>
              <div className="form-group row mb-2">
                <label className="col-sm-3 col-form-label text-left">Status</label>
                <div className="col-sm-9">
                  <Select name="statusCode" placeholder={"Status"}
                    value={(formData.mStatuses ?? []).find(({ value }) => { return value === state.statusCode }) ?? ""}
                    options={formData.mStatuses ?? []}
                    onChange={handleOnChangeSelect}
                    isClearable={true} isSearchable={true} />
                </div>
              </div>
              <div className="form-group row mb-1">
                <label className="col-sm-3 col-form-label">Shipment/ Reff</label>
                <div className="col-sm-9">
                  <input type="text" name="shipmentReff" value={state.shipmentReff ?? ""} onChange={handleOnChangeInputText} className="form-control form-control-sm" />
                </div>
              </div>
              <div className="form-group row my-2">
                <label className="col-sm-3 col-form-label">&nbsp;</label>
                <div className="col-sm-8">
                  <button type="button" className="btn btn-sm btn-primary me-2" onClick={searchForm}><span className="fa fa-sm fa-search"></span> Search</button>
                  <button type="button" className="btn btn-sm btn-primary me-2" onClick={() => { }}><span className="fa fa-sm fa-download"></span> Download</button>
                  <button type="button" className="btn btn-sm btn-primary me-2" onClick={(e) => { openShipmentForm(null, e) }}><span className="fa fa-sm fa-download"></span> New</button>
                </div>
              </div>
            </div>
            <div className='col-sm-4'>
              <div className="form-group row mb-2">
                <label className="col-sm-3 col-form-label text-left">Shipper</label>
                <div className="col-sm-9">
                  <Select name="shipperCode" placeholder={"Shipper"}
                    value={(formData.mShippers ?? []).find(({ value }) => { return value === state.shipperCode }) ?? ""}
                    options={formData.mShippers ?? []}
                    onChange={handleOnChangeSelect}
                    isClearable={true} isSearchable={true} />
                </div>
              </div>
              <div className="form-group row mb-2">
                <label className="col-sm-3 col-form-label text-left">Courier</label>
                <div className="col-sm-9">
                  <div className="row">
                    <div className="col-sm-6">
                      <Select name="courierCode" placeholder={"Status"}
                        value={(formData.mCouriers ?? []).find(({ value }) => { return value === state.courierCode }) ?? ""}
                        options={formData.mCouriers ?? []}
                        onChange={handleOnChangeSelect}
                        isClearable={true} isSearchable={true} />
                    </div>
                    <div className="col-sm-6">
                      <Select name="serviceType" placeholder={"Service Type"}
                        value={(formData.mServiceType ?? []).find(({ value }) => { return value === state.courierCode }) ?? ""}
                        options={formData.mServiceType ?? []}
                        onChange={handleOnChangeSelect}
                        isClearable={true} isSearchable={true} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="form-group row mb-2">
                <label className="col-sm-3 col-form-label text-left">Tracking No</label>
                <div className="col-sm-9">
                  <input type="text" name='waybillNo' className="form-control form-control-sm" value={state.waybillNo} onChange={handleOnChangeInputText} placeholder="Tracking No" />
                </div>
              </div>
            </div>
            <div className='col-sm-4'>
              <div className="form-group row mb-2">
                <label className="col-sm-3 col-form-label text-left">Batch Upload</label>
                <div className="col-sm-9">
                  <input type="text" name='batchUpload' className="form-control form-control-sm" value={state.batchUpload} onChange={handleOnChangeInputText} placeholder="Batch Upload" />
                </div>
              </div>
            </div>
          </div>
        </PanelBody>
      </Panel>
      <Panel>
        <PanelBody>
          <div className="table table-hover mb-0 text-dark">
            <table className="table table-sm table-hover table-striped mb-0 text-dark">
              <thead className='bg-lime-400 fw-bold'>
                <tr>
                  <th>No.</th>
                  <th className='w-90px'>Date</th>
                  <th>Shipment#</th>
                  <th>Shipper</th>
                  <th>Shipper Name</th>
                  <th>Consignee</th>
                  <th>Dest. City - District</th>
                  <th className='w-90px'>Postal Code</th>
                  <th>Package Description</th>
                  <th className='w-60px'>Weight</th>
                  <th>Internal.Tracking</th>
                  <th>Courier</th>
                  <th>Ext.Tracking No#</th>
                  <th>Receiver Name</th>
                  <th>Received Date</th>
                  <th>Last Update</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {(dataTable ?? []).map((val, key) => {
                  return (
                    <tr className='fs-8 fw-light' key={key}>
                      <td>{((formData.currentPage - 1) * formData.rowsPerPage) + (key + 1)}.</td>
                      <td>{moment(val.shipment_date).format('YYYY-MM-DD')}</td>
                      <td>{val.shipment_no}</td>
                      <td>{val.account_code}</td>
                      <td>{val.shipper_name}</td>
                      <td>{val.receiver_name}</td>
                      <td>{val.receiver_district_name} - {val.receiver_city_name}</td>
                      <td>{val.receiver_postalcode}</td>
                      <td>{val.package_description}</td>
                      <td className='text-end me-3'>{val.actual_weight ?? val.declare_weight} Kg</td>
                      <td>{val.internal_tracking_no}</td>
                      <td>{val.courier_code}</td>
                      <td>{val.courier_tracking_no}</td>
                      <td>{val.received_by_name}</td>
                      <td>{val.actual_received_date}</td>
                      <td>{moment(val.updated_at).format('YYYY-MM-DD HH-mm:ss')}</td>
                      <td>{val.status_code}</td>
                      <td><button className='btn btn-xs me-3' onClick={(e) => openShipmentForm(val.uid, e)} data-uid={val.uid}><i className='fa fa-pen-to-square'></i></button> <button className='btn btn-xs'><i className='fa fa-trash text-danger' onClick={() => {
                        setFormData(prevState => ({
                          ...prevState,
                          name: val.shipment_no,
                          id: val.uid
                        }))
                        // setPromptDeleteIsOpen(true);
                      }}></i></button></td>
                    </tr>)
                })}
              </tbody>
              <tfoot>

              </tfoot>
            </table>
          </div>
        </PanelBody>
        <PanelFooter>
          <div className='row'>
            <div className="col-sm-12">
              <Pagination
                currentPage={formData.currentPage ?? 1}
                totalRows={formData.totalRows ?? 1}
                pageSize={formData.rowsPerPage ?? 50}
                onPageChange={onChangePageHandler}
                selectedPageHandler={onChangePageSelectHandler}
              />
            </div>
          </div>
        </PanelFooter>
      </Panel>
      <div>
        <Modal
          isOpen={modalIsOpen}
          onAfterOpen={() => { }}
          onRequestClose={() => setIsOpen(false)}
          style={customStyles}
          ariaHideApp={false}  >
          <ShipmentForm props={{ uid: modalUid }} />
        </Modal>
      </div>
    </div>
  )
}

export default ShipmentList;